import { Image } from "primereact/image";
import logo from '../../assets/images/logo/ansa-logo-default.png';
import merdekaLogo from '../../assets/images/logo/ansa-logo-merdeka.png';
import React from "react";
import { Button } from "primereact/button";
import { isMerdekaWindow } from "../../utils/merdeka-theme";

const Login = () => {
  // Same 700x200 box as the default lockup, so no layout rule changes.
  const heroLogo = isMerdekaWindow() ? merdekaLogo : logo;

  return (
    <div className="login-container d-m-row">
      {/* Left Section */}
      <div className="login-image-section d-flex">
        <div className="image-content">
          <Image src={heroLogo} width="40%" alt="logo" />
          <h1 className="color-light">{`ANSA Superapp`}{":"}</h1>
          <h3 className="color-light fw-regular">{"Your Gateway to Comprehensive Services in One Tap"}</h3>
        </div>
      </div>

      {/* Right Section */}
      <div className="login-form-section">
        <form>
          <h2>{`Log In to ANSA`}</h2>
          <p className="formatted-text">{`Sign In now to access comprehensive services in insurance, finance, health, and more, all in one app!`}</p>
          <label htmlFor="email">{`Email Address`}</label>
          <input type="email" id="email" placeholder="e.g. johndoe@sample.com" required />
          <label htmlFor="password">{`Password`}</label>
          <input type="password" id="password" placeholder="password" required />
          <Button label="Login" type="submit" className="btn-primary"></Button>
          <p>{`Don’t have any account? `}<a href="/register">{`Create Account`}</a></p>
        </form>
      </div>
    </div>
  );
};

export default Login;